import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useController } from '../hooks/useController'
import { useDeleteDriverAssignments } from '../hooks/useDeleteDriverAssignments'
import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const { status, close } = useController()
  const [submitting, deleteDriverAssignments] = useDeleteDriverAssignments()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          loading={submitting}
          onClick={deleteDriverAssignments}
          variant="contained"
          testid="modal-primary-button"
          color="error"
        >
          {texts.confirmButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
